export const TIER_SELECTOR_HEIGHT = 300;
export const APPROX_TIER_ITEM_HEIGHT = 65;
